export default __webpack_public_path__ + "assets/4325a9675a318be7dca4b1e2964efe7f.ttf";